module.exports = __webpack_public_path__ + "static/media/leading-wellbeing@3x.69cbc572.png";